import {styled} from "@mui/material/styles";
import {
    Button,
    ButtonProps,
    Slider,
    Typography,
    Box,
    LinearProgress,
    SliderProps,
    InputBase,
    TypographyProps, IconButton
} from "@mui/material";


interface GradientButtonProps extends ButtonProps {
    gradientBackground?: boolean;
    gradientBorder?: boolean;
}

const GradientButtonWrapper = styled('div')`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%);
  border-radius: 8px;
  padding: 1px;
`;

const GradientButton = styled(Button)<GradientButtonProps>`
  background: ${({gradientBackground}) => gradientBackground ? 'linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%)' : 'white'};
  border-radius: 999px;
  height: 40px;
  text-transform: none;
  font-size: 14px;
  //padding: 0 12px;
  border: ${({gradientBackground, variant}) => gradientBackground || variant === "text" ? 'none' : '1px solid #E2E8F0'};
  box-shadow: ${({variant}) => variant === 'text' ? 'none' : '0px 1px 2px 0px #0F1A2A14'};
  color: ${({gradientBackground}) => gradientBackground ? 'white' : 'black'};
  
  &:disabled {
    background: ${({gradientBackground}) => gradientBackground ? 'linear-gradient(270deg, rgba(219, 59, 92, 0.5) 0%, rgba(137, 55, 165, 0.5) 46.57%, rgba(69, 90, 199, 0.5) 100%)' : 'white'};
    color: ${({gradientBackground}) => gradientBackground ? 'white' : 'black'};
  }

  &:hover {
    background: ${({gradientBackground}) => gradientBackground ? 'linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%)' : 'linear-gradient(0deg, #FEF7F8, #FEF7F8)'};
  }
`;

interface GradientTextProps extends TypographyProps {
    disabled?: boolean;
}

const GradientText = styled(Typography)<GradientTextProps>(({disabled}) => ({
    background: disabled ? 'linear-gradient(270deg, #9C9C9C 0%, #666666 46.57%, #787878 100%)': 'linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    whiteSpace: 'break-spaces'
}));

const GradientIconWrapper = styled('div')({
    display: 'inline-flex',
    background: 'linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%)',
    borderRadius: '50%',
    padding: '5px',
    '& svg': {
        mixBlendMode: 'screen',
    }
});

const GradientSlider = styled(Slider)((props) => ({
    color: 'transparent',
    height: 8,
    '& .MuiSlider-thumb': {
        height: 20,
        width: 20,
        backgroundColor: '#fff',
        border: '1px solid #E2E8F0',
        boxShadow: '0px 4px 8px -2px #0F1A2A1F',

        '&:hover': {
            boxShadow: '0 0 0 4px rgba(58, 133, 255, 0.16)',
        },
        '& .MuiSlider-valueLabel': {
            background: 'unset',
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 12px 16px -4px #0F1A2A14',
            borderRadius: 8,
            gap: 8,
            height: 32,
            '& *': {
                background: 'transparent',
                color: '#27364B',


            },
        },
    },
    '& .MuiSlider-track': {
        height: 4,
        borderRadius: 4,
        background: !props.disabled ? 'linear-gradient(270deg, #E28A9C 0%, #D378F2 38.54%, #5A9CFF 100%)' : 'light-gray'
    },
    '& .MuiSlider-rail': {
        height: 4,
        borderRadius: 4,
        opacity: 0.5,
        backgroundColor: '#CBD4E1',
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#CBD4E1',
    },
    '& .MuiSlider-markActive': {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
}));


const GradientLinearProgress = styled(LinearProgress)`
  &.MuiLinearProgress-root {
    height: 4px;
    border-radius: 5px;
  }

  & .MuiLinearProgress-bar {
    background: linear-gradient(270deg, #E28A9C 0%, #D378F2 38.54%, #5A9CFF 100%);;
  }

  & .MuiLinearProgress-colorPrimary {
    background-color: #455AC7;
  }
`;

const GradientProgressBar = () => {
    return (
        <Box sx={{width: '100%'}}>
            <GradientLinearProgress variant={"indeterminate"}/>
        </Box>
    );
};

export {
    GradientButton,
    GradientText,
    GradientButtonWrapper,
    GradientIconWrapper,
    GradientSlider,
    GradientProgressBar
};
